export const authUser = (auth = { user_token: null, objects: {}, person: {}, hasFavToUpdate: null }) => ({
  type: 'SET_USER_AUTH',
  auth
})

export const resetAuth = () => ({
  type: 'RESET_USER_AUTH'
})